module.exports = __webpack_public_path__ + "img/h3.19113ed6.jpg";